export const CLIENT_ID =
  '1039837819870-ndmnn8ieb3lua9fi7u5nj1ibmf0hhmbv.apps.googleusercontent.com'
